import React from 'react';
import { FormattedNumber } from 'react-intl';

interface IProps {
  price: number;
  commissionType?: string;
  commissionValue: number | string;
  format?: string;
  hasVariations?: boolean;
}

const CalculateCommissionAffiliate: React.FC<IProps> = ({ commissionType, commissionValue, format }) => {
  const commission = commissionType ? commissionValue : null;

  if (commissionType === 'V') {
    return <FormattedNumber format='BRL' value={commission as number} />;
  }

  if (commissionType === 'P') {
    return <>{commission}%</>;
  }

  return <FormattedNumber value={commission ? (commission as number) : 0} format={format || 'BRL'} />;
};

export default CalculateCommissionAffiliate;
